// extracted by mini-css-extract-plugin
export default {"week_box":"WeekBar_week_box__P8KI4","week_title":"WeekBar_week_title__wgMr4","day_card_container":"WeekBar_day_card_container__awjvS"};